module.exports = __webpack_public_path__ + "assets/FortiVPN.845d21fc.svg";